import { __assign } from "tslib";
import { maybeGetGlobal } from '../globals';
var COMMON_CONFIG_NAME = 'commonConfig';
var COMMON_CONFIG_KEYS = [
    'bsi',
    'brand',
    'siteRevision',
    'language',
];
function extractCommonConfigValues() {
    var globalObj = maybeGetGlobal();
    var commonConfigObj = globalObj === null || globalObj === void 0 ? void 0 : globalObj.commonConfig;
    if (!commonConfigObj) {
        return null;
    }
    var res = COMMON_CONFIG_KEYS.filter(function (key) { return typeof commonConfigObj[key] !== 'undefined'; }).reduce(function (_res, key) {
        var _a;
        return (__assign(__assign({}, _res), (_a = {}, _a[key] = commonConfigObj[key], _a)));
    }, {});
    if (typeof res.bsi !== 'undefined') {
        res.BSI = res.bsi;
        delete res.bsi;
    }
    if (typeof res.brand !== 'undefined' && typeof res.brand !== 'string') {
        console.warn("\"brand\" field should be of type \"string\", but got " + typeof res.brand + " (" + res.brand + ")");
        delete res.brand;
    }
    return Object.keys(res).length === 0 ? null : res;
}
export var commonConfig = function () {
    var _a;
    var commonConfigValues = extractCommonConfigValues();
    var value = commonConfigValues ? JSON.stringify(commonConfigValues) : '';
    return _a = {}, _a[COMMON_CONFIG_NAME] = encodeURIComponent(value), _a;
};
//# sourceMappingURL=common-config.js.map